import { Ban } from '@octopus-do/octopus-storybook/icons'
import { selectIsLoading } from '@store/loaders'
import type React from 'react'
import { useSelector } from 'react-redux'

import type { ApiKey } from '@/services/apiKeys'
import { clsJoin } from '@/utils'
import { formatDate, scopeLabel } from '../../utils'
import css from './styles.module.scss'

interface Props {
  apiKey: ApiKey
  onRevoke: (key: ApiKey) => void
}

export const ApiKeyRow: React.FC<Props> = ({ apiKey, onRevoke }) => {
  const revoking = useSelector(selectIsLoading(apiKey.id))

  return (
    <div className={css.row}>
      <div className={css.row_top}>
        <div className={css.row_main}>
          <div className={css.name}>{apiKey.name}</div>

          {apiKey.createdAt && (
            <div className={css.meta}>
              Created {formatDate(apiKey.createdAt)}
            </div>
          )}
        </div>

        <button
          type="button"
          className={css.revoke}
          disabled={revoking}
          onClick={() => onRevoke(apiKey)}
        >
          <Ban className={css.revoke_icon} width={16} height={16} />
          <span>Revoke</span>
        </button>
      </div>

      {apiKey.scopes && apiKey.scopes.length > 0 && (
        <div className={css.scopes}>
          {apiKey.scopes.map((scope) => (
            <span
              key={scope}
              className={clsJoin(
                css.scope,
                scope === 'write' && css.scope_write
              )}
            >
              {scopeLabel(scope)}
            </span>
          ))}
        </div>
      )}
    </div>
  )
}
